import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';

export interface SgAccordionTemplateContext<T> {
  $implicit: T;
}

@Component({
  selector: 'sg-accordion',
  templateUrl: './sg-accordion.component.html',
  styleUrls: ['./sg-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgAccordionComponent<T> {
  /** An array of any item type */
  @Input() items: T[];

  /** The name of a text property of an item from provided items array, will serve as the title of the expansion panel */
  @Input() titleProperty: keyof T;

  /** The indexes of items you want to be expanded by default  */
  @Input() expandedPanelIndexes: number[] = [];

  get multi() {
    return this._multi;
  }
  /** Whether the accordion should allow multiple expanded accordion items simultaneously. */
  @Input() set multi(value: BooleanInput) {
    this._multi = coerceBooleanProperty(value);
  }

  get allExpanded() {
    return this._allExpanded;
  }
  /** Expand all panels */
  @Input() set allExpanded(value: BooleanInput) {
    this._allExpanded = coerceBooleanProperty(value);
  }

  @ContentChild(TemplateRef) contentTemplate: TemplateRef<SgAccordionTemplateContext<T>>;

  /** @ignore */
  private _multi = false;
  /** @ignore */
  private _allExpanded = false;
}
